module.exports = __webpack_public_path__ + "img/ts4.082fdfea.png";